import { render, staticRenderFns } from "./uploadPicture.vue?vue&type=template&id=724d22c8&scoped=true&"
import script from "./uploadPicture.vue?vue&type=script&lang=js&"
export * from "./uploadPicture.vue?vue&type=script&lang=js&"
import style0 from "./uploadPicture.vue?vue&type=style&index=0&id=724d22c8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "724d22c8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/.jenkins/workspace/crm-ui/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('724d22c8')) {
      api.createRecord('724d22c8', component.options)
    } else {
      api.reload('724d22c8', component.options)
    }
    module.hot.accept("./uploadPicture.vue?vue&type=template&id=724d22c8&scoped=true&", function () {
      api.rerender('724d22c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/crm/order/salesOrder/uploadPicture.vue"
export default component.exports